(function () {
  // === assets/pickup-nearest.js — versão 17/09/2026 (formulário com checkbox da política de privacidade) ===
  var CHECKOUT_ATTR = 'Loja de recolha';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cached = null, enabled = false, sortedLists = new WeakSet();
  var FN = 'https://zdqjjyjacuzddmpzmhao.supabase.co/functions/v1/reserva-clique';

  function haversine(la1, lo1, la2, lo2) {
    var R = 6371, dLa = (la2 - la1) * Math.PI / 180, dLo = (lo2 - lo1) * Math.PI / 180;
    var a = Math.sin(dLa / 2) * Math.sin(dLa / 2) +
      Math.cos(la1 * Math.PI / 180) * Math.cos(la2 * Math.PI / 180) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function sortList(list, uLat, uLng) {
    if (!list || sortedLists.has(list)) return;
    sortedLists.add(list);
    var items = Array.prototype.slice.call(list.querySelectorAll('[data-pickup-store]'));
    items.map(function (el) {
      var la = parseFloat(el.dataset.lat), lo = parseFloat(el.dataset.lng);
      el._d = (isFinite(la) && isFinite(lo)) ? haversine(uLat, uLng, la, lo) : Infinity;
      return el;
    }).sort(function (a, b) { return a._d - b._d; }).forEach(function (el, i) {
      list.appendChild(el);
      el.classList.remove('is-nearest');
      var d = el.querySelector('[data-pickup-distance]');
      if (d && isFinite(el._d)) { d.textContent = ' · ' + (el._d < 10 ? el._d.toFixed(1) : Math.round(el._d)) + ' km'; d.hidden = false; }
      if (i === 0 && isFinite(el._d)) el.classList.add('is-nearest');
    });
  }

  function locate() {
    var list = document.querySelector('[data-pickup-nearest]');
    if (!list) return;
    if (cached) { sortList(list, cached.latitude, cached.longitude); return; }
    if (!navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(function (p) {
      cached = p.coords;
      sortList(document.querySelector('[data-pickup-nearest]'), cached.latitude, cached.longitude);
    }, function () {}, { timeout: 8000, maximumAge: 600000 });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#ShowPickupAvailabilityDrawer')) { enabled = true; locate(); return; }

    var btn = e.target.closest('[data-pickup-choose]');
    if (!btn) return;
    e.preventDefault();
    var id = Number(btn.dataset.variantId), name = btn.dataset.locationName;
    if (!id) return;
    btn.disabled = true; btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw 0; return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: (function () { var o = {}; o[CHECKOUT_ATTR] = name; return o; })() }) }); })
      .then(function () { window.location.href = root + 'checkout'; })
      .catch(function () { btn.disabled = false; btn.classList.remove('is-loading'); alert('Não foi possível adicionar ao carrinho. Tenta novamente.'); });
  });

  // ---- Reservar 48h: o clique no botão abre o formulário (nome + telemóvel) em vez de ir logo ao WhatsApp
  function telefoneOk(t) {
    var s = String(t || '').replace(/[^0-9+]/g, '').replace(/^\+?351/, '');
    if (/^9\d{8}$/.test(s)) return s;                 // português
    if (/^\+[1-9]\d{7,14}$/.test(s)) return s;        // internacional com indicativo
    return '';
  }
  // mensagem do cliente para a loja na língua do indicativo (+34 es, +33 fr, +44/+1/outros en, +351 ou 9… pt)
  function idioma(tel) { if (/^9\d{8}$/.test(tel) || /^\+351/.test(tel)) return 'pt'; if (/^\+34/.test(tel)) return 'es'; if (/^\+33/.test(tel)) return 'fr'; return 'en'; }
  var MSG = {
    pt: function (l, art, ref, tam, url, n, t) { return 'Olá equipa BStrong! Gostaria de reservar por 48h o seguinte artigo na loja ' + l + ':\n\n' + art + '\nRef: ' + ref + (tam ? '\nTamanho: ' + tam : '') + '\n\n' + url + '\n\nEm nome de: ' + n + ' · ' + t; },
    es: function (l, art, ref, tam, url, n, t) { return '¡Hola equipo BStrong! Me gustaría reservar durante 48 h este artículo en la tienda ' + l + ':\n\n' + art + '\nRef: ' + ref + (tam ? '\nTalla: ' + tam : '') + '\n\n' + url + '\n\nA nombre de: ' + n + ' · ' + t; },
    fr: function (l, art, ref, tam, url, n, t) { return "Bonjour l'équipe BStrong ! Je souhaite réserver pendant 48 h cet article au magasin " + l + ' :\n\n' + art + '\nRéf : ' + ref + (tam ? '\nTaille : ' + tam : '') + '\n\n' + url + '\n\nAu nom de : ' + n + ' · ' + t; },
    en: function (l, art, ref, tam, url, n, t) { return 'Hi BStrong team! I would like to reserve this item for 48h at the ' + l + ' store:\n\n' + art + '\nRef: ' + ref + (tam ? '\nSize: ' + tam : '') + '\n\n' + url + '\n\nOn behalf of: ' + n + ' · ' + t; }
  };
  var atual = null; // botão da loja que abriu o pop-up
  // A Shopify guarda em cache o HTML da gaveta por variante: nos artigos já vistos antes do pop-up entrar
  // no tema, a gaveta chega sem o <dialog>. Se faltar, o JS cria-o (mesmo HTML da secção) para o
  // formulário ser sempre obrigatório — sem ele o botão iria direto ao WhatsApp sem nome nem telemóvel.
  var HTML_DIALOGO =     '<p class="pickup-reserve-form__nota">Usamos o nome e o telem\u00f3vel s\u00f3 para a loja guardar o artigo 48\u00a0h e confirmar por WhatsApp. Ficam cifrados e apagam-se 30 dias depois. Sem marketing. <a href="/pages/politica-de-privacidade" target="_blank" rel="noopener">Pol\u00edtica de privacidade</a></p>' +
    '<label>Nome<input type="text" name="nome" maxlength="80" autocomplete="name" required placeholder="o teu nome"></label>' +
    '<label>Telem\u00f3vel<input type="tel" name="telefone" inputmode="numeric" maxlength="16" autocomplete="tel" required placeholder="9xx xxx xxx ou +34 \u2026"></label>' +
    '<label class="pickup-reserve-form__mel" aria-hidden="true">Website<input type="text" name="website" tabindex="-1" autocomplete="off"></label>' +
    '<p class="pickup-reserve-form__nota">Para tratar a tua reserva recolhemos o <b>nome</b> e o <b>telem\u00f3vel</b>: servem apenas para a loja guardar o artigo 48\u00a0h, confirmar por WhatsApp e enviar o c\u00f3digo de levantamento. Ficam protegidos (cifrados), s\u00f3 a loja escolhida os v\u00ea, e o telem\u00f3vel \u00e9 apagado 30 dias depois de a reserva fechar. Sem marketing. Podes pedir acesso ou apagamento a qualquer momento. <a href="/pages/politica-de-privacidade" target="_blank" rel="noopener">Pol\u00edtica de privacidade</a></p>' +
    '<label class="pickup-reserve-form__privacidade"><input type="checkbox" name="privacidade" required><span>Li e aceito a pol\u00edtica de privacidade</span></label>' +
    '<p class="pickup-reserve-form__erro" hidden></p>' +
    '<button type="submit" class="button button--primary" disabled>Enviar e abrir o WhatsApp</button>' +
    '</form>';
  function dialogo() {
    var d = document.querySelector('.pickup-reserve-dialog');
    if (d || typeof HTMLDialogElement === 'undefined') return d;
    d = document.createElement('dialog'); d.className = 'pickup-reserve-dialog'; d.setAttribute('aria-labelledby', 'PickupReserveTitle');
    d.innerHTML = HTML_DIALOGO; document.body.appendChild(d);
    return d;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.pickup-reserve-whatsapp');
    if (!a) return;
    var dlg = dialogo();
    if (!dlg || typeof dlg.showModal !== 'function') return; // browser sem <dialog> (muito antigo): link direto, e a loja pede os dados na conversa
    e.preventDefault();
    atual = a;
    var form = dlg.querySelector('.pickup-reserve-form');
    dlg.querySelector('[data-reserva-loja-nome]').textContent = a.dataset.reservaLoja || '';
    dlg.querySelector('[data-reserva-artigo]').textContent = (a.dataset.reservaTitulo || '') + (a.dataset.reservaTamanho ? ' · ' + a.dataset.reservaTamanho : '');
    form.querySelector('.pickup-reserve-form__erro').hidden = true;
    // a checkbox nunca fica pré-marcada: cada pedido volta a exigir o aceite
    var chk = form.querySelector('[name=privacidade]'); if (chk) chk.checked = false;
    var sub = form.querySelector('[type=submit]'); sub.disabled = true; sub.textContent = 'Enviar e abrir o WhatsApp';
    form.dataset.abertoEm = String(Date.now());
    dlg.showModal();
    var inp = form.querySelector('[name=nome]'); if (inp) inp.focus();
  });
  // o botão de enviar só liga com a checkbox marcada
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('.pickup-reserve-form [name=privacidade]')) return;
    var form = e.target.closest('.pickup-reserve-form');
    var sub = form && form.querySelector('[type=submit]');
    if (sub) sub.disabled = !e.target.checked;
  });
  document.addEventListener('click', function (e) {
    var dlg = dialogo(); if (!dlg || !dlg.open) return;
    if (e.target.closest && e.target.closest('.pickup-reserve-form__fechar')) { dlg.close(); return; }
    if (e.target === dlg) dlg.close(); // clique fora da caixa
  });
  // o tema cancela o Escape para a sua gaveta e isso anula o fecho nativo do <dialog>: fechamos nós, em captura
  document.addEventListener('keydown', function (e) {
    var dlg = dialogo();
    if (e.key === 'Escape' && dlg && dlg.open) { e.preventDefault(); e.stopPropagation(); dlg.close(); }
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.pickup-reserve-form');
    if (!form || !atual) return;
    e.preventDefault();
    var a = atual;
    var nome = (form.querySelector('[name=nome]').value || '').trim().slice(0, 80);
    var tel = telefoneOk(form.querySelector('[name=telefone]').value);
    var aceite = !!(form.querySelector('[name=privacidade]') || {}).checked;
    var erro = form.querySelector('.pickup-reserve-form__erro');
    if (!nome || !tel || !aceite) {
      erro.textContent = !nome ? 'Escreve o teu nome.' : !tel ? 'Telemóvel inválido: 9 dígitos, ou o indicativo do país com +.' : 'Para prosseguir tens de aceitar a política de privacidade.';
      erro.hidden = false; return;
    }
    erro.hidden = true;
    var sub = form.querySelector('[type=submit]'); sub.disabled = true; sub.textContent = 'A enviar…';
    // a mensagem para a loja leva o nome e o número escritos (a loja confere com o número da conversa), na língua do indicativo
    var msg = MSG[idioma(tel)](a.dataset.reservaLoja || '', a.dataset.reservaTitulo || '', a.dataset.reservaRef || '', a.dataset.reservaTamanho || '', location.href.split('#')[0], nome, tel);
    var wa = 'https://wa.me/' + (a.dataset.reservaWa || '') + '?text=' + encodeURIComponent(msg);
    var mel = (form.querySelector('[name=website]') || {}).value || '';
    fetch(FN, {
      method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ loja: a.dataset.reservaLoja || '', ref: a.dataset.reservaRef || '', tamanho: a.dataset.reservaTamanho || '', titulo: a.dataset.reservaTitulo || '', preco: a.dataset.reservaPreco || '', url: location.href, nome: nome, telefone: tel, website: mel, t: Number(form.dataset.abertoEm || 0), privacidade: aceite })
    }).then(function (r) {
      if (r.status === 429) { erro.textContent = 'Já pediste várias reservas hoje. Fala diretamente com a loja.'; erro.hidden = false; sub.disabled = false; sub.textContent = 'Enviar e abrir o WhatsApp'; return; }
      window.location.href = wa;
    }).catch(function () { window.location.href = wa; }); // sem rede para o hub: o WhatsApp abre na mesma
  });

  // Re-ordena quando a lista é re-injetada (mudança de tamanho), se o cliente já ativou
  new MutationObserver(function () {
    if (enabled && cached) sortList(document.querySelector('[data-pickup-nearest]'), cached.latitude, cached.longitude);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();